import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import EmailValidation from './pages/emailValidation';
import PasswordRecovery from './pages/passwordRecovery';
import Home from './pages/home';
import Redirect from './components/Redirect';
import './index.css';
import theme from './theme';
import App from './App';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
          <Routes>
              <Route path="/" element={<App />}>
                  <Route path="about" element={<Redirect url="https://www.truplaygames.com/about" />} />
                  <Route path="careers" element={<Redirect url="https://www.truplaygames.com/careers" />} />
                  <Route path="blog" element={<Redirect url="https://www.truplaygames.com/blog" />} />
                  <Route path="contact" element={<Redirect url="https://www.truplaygames.com/contact" />} />
                    <Route path="emailValidation" element={<EmailValidation />} />
                    <Route path="passwordRecovery" element={<PasswordRecovery />} />
                  <Route path="*" element={<Home />} />
              </Route>
          </Routes>
        </BrowserRouter>
    </ThemeProvider>,
  </React.StrictMode>,
  document.getElementById('root')
);
